var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.44758 0.219668C0.757895 -0.0732225 1.26103 -0.0732225 1.57134 0.219668L6.07416 4.46967C6.38449 4.76256 6.38449 5.23744 6.07416 5.53033L1.57134 9.7803C1.26103 10.0732 0.757895 10.0732 0.44758 9.7803C0.137265 9.4874 0.137265 9.0126 0.44758 8.7197L4.38855 5L0.44758 1.28033C0.137265 0.987438 0.137265 0.512558 0.44758 0.219668Z",
    fill: "#00ABFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.ce86cad29d6d51bd63751e8d32569187.svg";
export { ForwardRef as ReactComponent };